import { render, staticRenderFns } from "./Legalization.vue?vue&type=template&id=29bf4d5a&scoped=true&"
import script from "./Legalization.vue?vue&type=script&lang=js&"
export * from "./Legalization.vue?vue&type=script&lang=js&"
import style0 from "./Legalization.vue?vue&type=style&index=0&id=29bf4d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bf4d5a",
  null
  
)

export default component.exports